import { render, staticRenderFns } from "./AdminComparativeView.vue?vue&type=template&id=2be59fe6&scoped=true"
import script from "./AdminComparativeView.vue?vue&type=script&lang=js"
export * from "./AdminComparativeView.vue?vue&type=script&lang=js"
import style0 from "./AdminComparativeView.vue?vue&type=style&index=0&id=2be59fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be59fe6",
  null
  
)

export default component.exports